// extracted by mini-css-extract-plugin
export default {"message":"LoadingOrErrorMessage-module_message__qwmXB"};